import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getVibeLimitationsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.vibeLimitations);

export const getVibeLimitationsData = createSelector(getVibeLimitationsState,
  (state: any) => state?.data
);

export const getVibeLimitationsLoading = createSelector(getVibeLimitationsState,
  (state: any) => state?.loading
);

export const getVibeLimitationsLoaded = createSelector(getVibeLimitationsState,
  (state: any) => state?.loaded
);

export const getVibeLimitationsError = createSelector(getVibeLimitationsState,
  (state: any) => state?.error
);
